import { Controller } from "@hotwired/stimulus"

// Écran de correspondance de l'import : l'exercice n'est demandé que pour un champ saisi par exercice.
export default class extends Controller {
  static targets = ["select", "year"]

  connect() { this.toggle() }

  toggle() {
    const option = this.selectTarget.selectedOptions[0]
    this.yearTarget.hidden = option?.dataset.byYear !== "true"
  }
}
